<template>
  <v-app id="inspire">
    <v-navigation-drawer    
      v-model="drawer"
      app
      temporary
    >
      <!--  -->
      <Sidebar v-if="$user" v-bind:name="$user.name.first + ' ' + $user.name.last" v-bind:img-src="$user.picture.thumbnail"/>
    </v-navigation-drawer>
    
    <v-app-bar app color="light-green" v-if="$route.name != 'Map'">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>Reco</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <!--  
      -->
      <router-view></router-view>
      
    </v-main>
    <FAB color="light-green" :hide='hideFab' :icon='btnicon' @click='doFABaction(fabAction)'/>    
    <Footer style="z-index:1000" v-bind:page-index="value" @index-change="setPageIndex"/>
  </v-app>
</template>

<script>  
  import Footer from './components/Footer'
  import Sidebar from './components/Sidebar'
  import FAB from './components/FAB'
  import EventBus from './bus';

  export default {
    data: () => ({ 
      drawer: false,
      value:0,
      hideFab: false,
      btnicon:'mdi-arrow-down',
      fabAction: () => {
        window.scrollTo(0,document.body.scrollHeight);
      },
    }),
    components:{      
      Footer,
      Sidebar,
      FAB,
    },
    mounted()
    {
      console.log(this.$users);
    },
    methods : {
      setPageIndex: function(i,name,icon)
      {                
        this.value = i;
        this.$router.push(name);
        if(icon === 'none')
        {
          this.hideFab = true;
        }else{
          this.hideFab = false;
          this.btnicon = icon;
        }
      },
      doFABaction(action)
      {
        EventBus.$emit('fab-action');
        action();
      }
    }
  }
</script>